import * as React from 'react';

/**
 * IspLeftContainer component
 * @extends {React.Component}
 */
class IspLeftContainer extends React.Component {
    public render(): JSX.Element | null {
        return (
            <>
                <div id='isp_left_container' className='isp_left_container' data-no-instant>
                    <div id='isp_left_container_header' className='isp_left_container_header'/>
                    <div id='isp_left_container_facets' className='isp_left_container_facets'>
                        <div className='isp_single_facet_wrapper isp_single_facet_wrapper_skeleton'/>
                        <div className='isp_single_facet_wrapper isp_single_facet_wrapper_skeleton'/>
                        <div className='isp_single_facet_wrapper isp_single_facet_wrapper_skeleton'/>
                        <div className='isp_single_facet_wrapper isp_single_facet_wrapper_skeleton'/>
                        <div className='isp_single_facet_wrapper isp_single_facet_wrapper_skeleton'/>
                    </div>
                </div>
            </>
        );
    }
}
export default IspLeftContainer;